import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { gameActions } from "../../action/GameAction";
import { Helmet } from "react-helmet";
import Viewdetailedresults from "./Viewdetailedresults";
import CommonPopup from "./WinnerPopup";
import { appVariables } from '../../helpers/appVariables';
import { history } from "../../helpers/history";
import { commonClass } from "../../helpers/commonClass";
import WinnersList from "./WinnersList";
import moment from 'moment';
import DateRangePicker from "react-bootstrap-daterangepicker";


class Previousresult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawType: props.drawtype,
            fromDate: '',
            toDate: '',
            serverDate: new Date(),
            PastDrawStateObj: {},
            ViewAllResultFlag: false,
            IsValidData: false,
            _dbdrawType: props.send_db_id,
            UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {},
            PrevDrawFlag: false,
            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: [],
            startDate: moment().subtract(30, 'days'),
            endDate: moment(),
        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            AnotherPrevResult: props.AnotherPrevResult,
            RaffleResult: props.RaffleResult && props.RaffleResult.RaffleResultLst,
            // RaffleResult: props.RaffleResult,
            breakdownlist: props.breakdownlist
        };
    };
    onchangeDate = (fdate, tdate) => {
        let checkdate = this.validatedate(fdate, tdate);
        if (checkdate) {
            this.props.GetPreviousResult(this.state._dbdrawType, fdate, tdate, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, 1);
        }
    }
    validatedate = (fromDate, toDate) => {
        let datepattern = /(\d{2})\/(\d{2})\/(\d{4})/;
        var fr = (new Date(fromDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var to = (new Date(toDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var currDate = ("0" + this.state.serverDate.getDate()).slice(-2) + "/" + ("0" + (this.state.serverDate.getMonth() + 1)).slice(-2) + "/" + this.state.serverDate.getFullYear();
        var lserverDate = (new Date(currDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        if (fr > lserverDate || to > lserverDate) {
            this.showMsg('lblNoFuturedate');
            return false;
        }
        return true;
        if (fr > to) {
            this.showMsg('lblFrdateGreater');
            return false;
        }
        fr.setHours(0, 0, 0, 0);
        to.setHours(0, 0, 0, 0);
        if (fr > to || fr < to) {
            var date = this.state.serverDate;
            var ss = ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
            var cdate = new Date(new Date(ss.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var lfr = ("0" + fr.getDate()).slice(-2) + "/" + ("0" + (fr.getMonth() + 1)).slice(-2) + "/" + fr.getFullYear();
            var lto = ("0" + to.getDate()).slice(-2) + "/" + ("0" + (to.getMonth() + 1)).slice(-2) + "/" + to.getFullYear();
            var fdate = new Date(new Date(lfr.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var tdate = new Date(new Date(lto.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            cdate.setHours(0, 0, 0, 0);
            fdate.setHours(0, 0, 0, 0);
            tdate.setHours(0, 0, 0, 0);
            if (fdate > cdate && tdate > cdate) {
                this.showMsg('lblCurrentDate');
                return false;
            }
        }
        return true;
    }

    componentDidMount() {
        window.FavouritesPopUp();
        //window.Loaddaterange(1);
        //var lstrdate = document.getElementById('mydaterange').value;
        // var date = new Date();
        // var ss = ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();

        // var date1 = new Date();
        // date1.setDate(date1.getDate() - 30);

        // var ss1 = ("0" + date1.getDate()).slice(-2) + "/" + ("0" + (date1.getMonth() + 1)).slice(-2) + "/" + date1.getFullYear();
        // let _startDate = ss1;
        // let _endDate = ss;
        // var lstrdate = _startDate + "-" + _endDate
        // this.onchangeDate(lstrdate);
        // window.getdateFromJS(this.onchangeDate);
        this.handleCallback(this.state.startDate, this.state.endDate)
        localStorage.setItem('drawtabId', 1);
    }
    componentDidUpdate(prevState, prevProps) {
        // if (this.state.AnotherPrevResult != prevProps.AnotherPrevResult && this.state.AnotherPrevResult && this.state.AnotherPrevResult.length > 0 && this.state.AnotherPrevResult != null && this.state.IsValidData == false) {
        //     this.state.IsValidData = true;
        //     window.allDrawResultPopUp();
        // }
        if (this.state.AnotherPrevResult != prevProps.AnotherPrevResult) {
            this.LoadTransactionData()
        }
    }
    showMsg = (lstrError) => {
        this.props.alertError(this.props.t(lstrError));
    }
    GotoPastResultPage = () => {
        this.setState({ ViewAllResultFlag: true })
    }
    BactGotoPastResultPage = () => {
        setTimeout(() => {
            window.allDrawResultPopUp();
            window.FavouritesPopUp();
            window.Loaddaterange(2, this.state.fromDate, this.state.toDate);
            window.getdateFromJS(this.onchangeDate);
            //document.getElementById('mydaterange').value = this.state.fromDate + " - " + this.state.toDate;
        });
        this.state.ViewAllResultFlag = false;
        this.setState({ ViewAllResultFlag: false });
    }
    GetLatestWinner = (drawid) => {
        let draw_id = 0;
        if (drawid != 0) {
            draw_id = drawid.draw_id;
            this.setState({ PastDrawStateObj: drawid })
        }
        this.props.GetRaffleResults(this.state._dbdrawType, draw_id, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
        this.setState({ PrevDrawFlag: true })
    }

    closeWinnerList = () => {
        this.setState({ PrevDrawFlag: false })
    }
    GameWiseShowText = (game_groupid) => {
        const { t } = this.props;
        let CheckMy = Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my';
        switch (parseInt(game_groupid)) {
            case 1:
                if (CheckMy) {
                    return 'Fortune6 Live 6D Results – Are You a Winner?';
                }
                else {
                    // return 'Fortune6 Draw Live Results – Latest 6D Winning Numbers';
                    return 'Fortune6 Draw Live Results – Latest Winning Numbers';
                }
            case 2:
                if (CheckMy) {
                    return 'Super6 Draw Live – 6D Jackpot Numbers Revealed';
                }
                else {
                    // return 'Super6 Draw Live Results – Latest 6D Jackpot Numbers';
                    return 'Super6 Draw Live Results – Latest Jackpot Numbers';
                }

            case 3:
                if (CheckMy) {
                    return 'Magic5 Draw – Real-Time 5D Results';
                }
                else {
                    // return 'Magic5 Draw Live Results – Today’s 5D Draw Results';
                    return 'Magic5 Draw Live Results – Today’s Draw Results';
                }

            case 4:
                if (CheckMy) {
                    return '1d Live Results Lucky1draws';
                }
                else {
                    return 'Lucky1 Draw Live Results – Instant Results & Winners';
                }

            case 5:
                if (CheckMy) {
                    return 'Dream5 Live Results – 5D Draw Outcomes';
                }
                else {
                    return "Dream5 Draw Live Results – Today's Winning Numbers";
                }

            case 6:
                if (CheckMy) {
                    return 'Rush3 Live 3D Results – Today’s Winning Numbers';
                }
                else {
                    // return 'Rush3 Draw Live Results – 3D Fast Draw Outcomes';]
                    return 'Rush3 Draw Live Results – Fast Draw Outcomes';
                }
            case 12:
                return t('lblMainDrawResult')
            default:
                if (CheckMy) {
                    return 'Super6 Draw Live – 6D Jackpot Numbers Revealed';
                }
                else {
                    // return 'Super6 Draw Live Results – Latest 6D Jackpot Numbers';
                    return 'Super6 Draw Live Results – Latest Jackpot Numbers';
                }
        }
    }

    handleCallback = (start, end) => {
        if (start && end) {
            this.setState(
                {
                    startDate: start.format('DD/MM/YYYY'),
                    endDate: end.format('DD/MM/YYYY'),
                },
                () => {
                    this.onchangeDate(this.state.startDate, this.state.endDate);
                }
            );
        }
    };

    LoadTransactionData = () => {
        if (this.props.AnotherPrevResult && this.props.AnotherPrevResult && this.props.AnotherPrevResult.length > 0) {
            let ldt = []
            ldt = this.props.AnotherPrevResult;
            this.setState({ lfilterdt: ldt });
            let ltotpage = Math.trunc(ldt.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(ldt.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }


    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }


    render() {
        const { t } = this.props;
        return (
            <>
                {/* {process.env.REACT_APP_MODE == "production" &&                  
                    <Helmet>
                        {this.state.drawType == 9 ? <title>Gulf Ticket - Fortune 6 Draw Results - Meet Our Winners</title>
                            : this.state.drawType == 10 ? <title>Gulf Ticket - Super 6 Draw Results - Meet Our Winners</title>
                                : this.state.drawType == 13 ? <title>Gulf Ticket - Lucky 1 Draw Results - Meet Our Winners</title>
                                    : this.state.drawType == 14 ? <title>Gulf Ticket - Dream 5 Draw Results - Meet Our Winners</title>
                                        : this.state.drawType == 15 ? <title>Gulf Ticket - Rush 3 Draw Results - Meet Our Winners</title>
                                            : <title>Gulf Ticket - Magic 5 Draw Results - Meet Our Winners</title>}
                        <meta name="description" content="Stay ahead of the game with Gulf Ticket's draw results, featuring the latest winning numbers for both Fortune 6 ,Super 6 and Magic 5 lotteries." />
                        <meta name="keywords" content="Gulf Ticket, lottery, UAE Lucky 1,Pick 3,Dream 5,Magic 5, Fortune 6, Super 6 draw results, raffle, lottery, winners, draw, winning numbers, mega prize, Gulf Ticket schedule and results" />

                        {this.state.drawType == 9 ? <>
                            <meta property="og:title" content="Gulf Ticket - Fortune 6 Draw Results - Meet Our Winners" />
                            <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/Fortune6.png" />
                        </> :
                            this.state.drawType == 10 ?
                                <>
                                    <meta property="og:title" content="Gulf Ticket - Super 6 Draw Results - Meet Our Winners" />
                                    <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/super6.jpg" />
                                </>
                                :
                                this.state.drawType == 13 ?
                                    <>
                                        <meta property="og:title" content="Gulf Ticket - Lucky 1 Draw Results - Meet Our Winners" />
                                        <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/lucky-1.jpg" />
                                    </>
                                    :
                                    this.state.drawType == 14 ?
                                        <>
                                            <meta property="og:title" content="Gulf Ticket - Dream 5 Draw Results - Meet Our Winners" />
                                            <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/dream-5.jpg" />
                                        </>
                                        :
                                        this.state.drawType == 15 ?
                                            <>
                                                <meta property="og:title" content="Gulf Ticket - Rush 3 Draw Results - Meet Our Winners" />
                                                <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/pick-3.png" />
                                            </>
                                            :
                                            <>
                                                <meta property="og:title" content="Gulf Ticket - Magic 5 Draw Results - Meet Our Winners" />
                                                <meta property="og:image" content="https://gulfticket.com/assets/img/past-draws/magic-5.jpg" />
                                            </>
                        }
                        <meta property="og:site_name" content="Gulf Ticket" />
                        <meta property="og:url" content="https://gulfticket.com" />
                        <meta property="og:description" content="Stay ahead of the game with Gulf Ticket's draw results, featuring the latest winning numbers for both Fortune 6 ,Super 6 and Magic 5 lotteries." />
                        <meta property="og:type" content="website" />

                    </Helmet>
                } */}

                {/* margin-left-7 true Part */}
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-Past-Draw-Results.png" />{t('lblPastDrawRes')}</h1>
                    <p>{t('lblCurrRec')}</p>
                    {!this.state.PrevDrawFlag &&
                        <div class="filters margin-top-20">
                            <div class="filtersCont">
                                <span>
                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: this.state.startDate,
                                            endDate: this.state.endDate,
                                            locale: {
                                                format: 'DD/MM/YYYY',
                                                separator: ' - ',
                                                applyLabel: 'Apply',
                                                cancelLabel: 'Cancel',
                                            },
                                        }} onCallback={this.handleCallback}
                                    >
                                        <input id='datepicker1' value={`${this.state.startDate} - ${this.state.endDate}`} readOnly />
                                    </DateRangePicker>
                                </span>
                            </div>
                            <div class="filtersBtn padding-top-0">
                                <a >{t("lblapply")}</a>
                            </div>
                        </div>
                    }
                    {this.state.PrevDrawFlag == true && <div class="filters margin-top-20"><div class="filtersBtn padding-top-0" onClick={() => { this.closeWinnerList() }}><a > {t('lblBack')} </a></div></div>}
                </div>
                {this.state.PrevDrawFlag == false &&
                    <>
                        <div class="favourites">
                            <div class="latestDrawRslt padding-bottom-0">
                                {this.props.AnotherPrevResult && this.props.AnotherPrevResult && this.props.AnotherPrevResult.length > 0 ? <ul>
                                    <li>
                                        <div class="w-30 head">{t('lblWinningCombination')}</div>
                                        <div class="w-20 head"> {t('lbldate')}</div>
                                        <div class="w-15 head">{t('lblTotalPrize')}</div>
                                        <div class="w-15 head">{t('lblTotalWinners')}</div>
                                        <div class="w-20 head">&nbsp;</div>
                                    </li>
                                    {this.state.lfilterdt && this.state.lfilterdt.length > 0 && this.state.lfilterdt.slice(this.state.startinx, this.state.endinx).map((prevresult, index) =>
                                        <li class={`lto-${this.state.drawType}`}>
                                            <div class="w-30">
                                                {prevresult.win_number && prevresult.win_number.split(';').length > 0 && prevresult.win_number.split(';').map((winNos, index) =>
                                                    <div class={`lottoRsltBalls lto-${this.state.drawType}-bg-color`}>{winNos}</div>
                                                )}
                                            </div>
                                            <div class="w-20">{prevresult && prevresult.draw_date.replace(',', ' ')}</div>
                                            <div class="w-15 bold">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(prevresult.total_prize)}</div>
                                            <div class="w-15">{prevresult.total_winner}</div>
                                            <div class="w-20 winBtn">
                                                <a onClick={() => { this.GetLatestWinner(prevresult) }}>{t('lblWinner')}</a>
                                            </div>
                                        </li>
                                    )
                                    }

                                    {/* <li>
                                    <div className="pastDrawTopHead">
                                        <div className="width65">
                                            <div className={`winnerPost bg-game${this.state.drawType}`}>
                                                {(this.state.drawType != 13 && this.state.drawType != 15) ? <h3>{t('lblViewWinners')}
                                                    {this.state.drawType == 1 ? appVariables.PRIZE_STRUCT_FORTUNE5.RaffleWinCount :
                                                        this.state.drawType == 2 ? appVariables.PRIZE_STRUCT_SUPER6.RaffleWinCount :
                                                            this.state.drawType == 5 ? appVariables.PRIZE_STRUCT_DREAM5.RaffleWinCount :
                                                                appVariables.PRIZE_STRUCT_MAGIC5.RaffleWinCount} {t('lblguranteed')}<br />{t('lblWinner')}</h3> : <h3>{t('lblViewWinners')}{t('lblWinner')}</h3>}
                                                <div className="flexCenter gap20">
                                                    {(this.state.drawType != 13 && this.state.drawType != 15) && <div>
                                                        <a id="show-popup" className="show-popup smallpopupopen" onClick={() => { this.GetLatestWinner(0) }}>{t('lblViewLatestRes')}</a>
                                                    </div>}
                                                    <div>
                                                        <a onClick={() => this.GotoPastResultPage()}>{t('lblViewAllDrawHistory')}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        VIEW LATEST WINNERS POPUP
                                        <div id="popup-container" className="popup-container smallpopup">
                                            <div id="popup-content" className="popup-content no-scrollbar" >
                                                <div id="rightAlign" className="rightAlign">
                                                    <button id="close-popup" className="close-popup smallpopupclose">
                                                        <img src="./assets/img/icons/Close-Btn.svg" alt="Close Icon" />
                                                    </button>
                                                </div>
                                                <div className={`popup-main bg-game${this.state.drawType}`}>
                                                    {this.state.drawType != 13 ?
                                                        <div className="viewLatestHead1">
                                                            {this.state.RaffleResult && this.state.RaffleResult.length > 0 && this.state.RaffleResult[0].draw_date && <div className="dateDraw">
                                                                <div>{this.state.RaffleResult && this.state.RaffleResult.length > 0 && this.state.RaffleResult[0].draw_date && this.state.RaffleResult[0].draw_date.length > 0 && <> {this.state.RaffleResult[0].draw_date.split(',')[0].split(' ')[1]} {this.state.RaffleResult[0].draw_date.split(',')[0].split(' ')[2]}</>}</div>
                                                                <div>{this.state.RaffleResult && this.state.RaffleResult.length > 0 && this.state.RaffleResult[0].draw_date && this.state.RaffleResult[0].draw_date.length > 0 && this.state.RaffleResult[0].draw_date.split(',')[1].split(' ')[0]}</div>
                                                            </div>}
                                                            <div className="drawHeader">
                                                                {this.state.RaffleResult && this.state.RaffleResult.length > 0 ? <div>{this.state.RaffleResult.length} {t('lblguranteed')}</div> :
                                                                    <div>{this.state.drawType == 1 ? appVariables.PRIZE_STRUCT_FORTUNE5.RaffleWinCount :
                                                                        this.state.drawType == 2 ? appVariables.PRIZE_STRUCT_SUPER6.RaffleWinCount :
                                                                            this.state.drawType == 5 ? appVariables.PRIZE_STRUCT_DREAM5.RaffleWinCount :
                                                                                appVariables.PRIZE_STRUCT_MAGIC5.RaffleWinCount} {t('lblguranteed')}</div>}
                                                                <div>{t('lblRaffleWinners')}</div>
                                                            </div>
                                                        </div>
                                                        : <div className="viewLatestHead1"><div className="drawHeader"><div>{t('lblViewWinners')}{t('lblWinner')}</div></div></div>}
                                                    <div className="winnersList bg-white">
                                                        {this.state.RaffleResult && this.state.RaffleResult.length == 0 &&
                                                            <div>
                                                                <p className='marginAuto' style={{ textAlign: "center" }}>{t('lblresultprogress')}</p>
                                                            </div>}
                                                        {this.state.RaffleResult && this.state.RaffleResult.length > 0 && this.state.RaffleResult.map((result, inx) =>
                                                            <div className="winnersListAlign" key={`ai_${inx}`}>
                                                                <div className="firstColumnName">
                                                                    <div>{result.Player_name}</div>
                                                                    <div>{result.Player_age} {result.Player_age ? " " + t('lblOld') : ""}  {result.Player_city ? " " + t('lblFrom') : ""}<span>{result.Player_city}</span></div>
                                                                </div>
                                                                <div className="secondColumnDetails">
                                                                    <div><span>{t('lblRafflaID')}:</span><span> #{result.raffleid}</span></div>
                                                                    <div><span>{t('lblWon')}:</span> <span> {this.props.appvariables.currency}  {commonClass.aedCrnyConvert(result.winamount)}</span></div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <button
                                                        className="capitalize py-1 px-5 !text-white font-semibold mx-auto !bg-brand rounded-md  border-2  close-popup smallpopupclose">
                                                        {t('lblclose')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        MAIN DRAW RESULTS CLICK POPUP
                                        <CommonPopup PastDrawStateObj={this.state.PastDrawStateObj} drawType={this.state.drawType} />
                                    </div>

                                    <div className="maindrawContent">
                                        <h1 className={`mainDrawWinnerText ${this.state.drawType == 2 ? 'marginBottomNone' : ''}`}>{this.GameWiseShowText(this.state._dbdrawType)}</h1>
                                        <div className="currentlyShowing">{t('lblCurrRec')}</div>
                                        {(this.state.AnotherPrevResult == null || (this.state.AnotherPrevResult && this.state.AnotherPrevResult.length == 0)) &&
                                            <p className="mainDrawWinnerText" style={{ textTransform: "initial", fontSize: "20px" }}>{t('lblNoRecordFound')}</p>
                                        }
                                        <div className="row">
                                            {this.props.AnotherPrevResult && this.props.AnotherPrevResult.map((prevresult, ine) =>
                                                <div className="pastDrawResultsSection" key={`aj_${ine}`}>
                                                    <div className="pastDrawResultSubSection bg-white">
                                                        <div className={`dateAbsoluteSection bg-game${this.state.drawType}`}>{prevresult && prevresult.draw_date.replace(',', ' ')}</div>
                                                        <div className="WinningContainer">
                                                            <div className="WinningCome dashed-border">
                                                                <span>{t('lblWinningCombination')}</span>
                                                                {this.state.drawType != 13 &&
                                                                    <div className={`WinBall border-game${this.state.drawType}`}>
                                                                        {prevresult.win_number && prevresult.win_number.split(';').length > 0 && prevresult.win_number.split(';').map((winNos, index) =>
                                                                            <span key={`ak_${index}`} className={`bg-game${this.state.drawType} !text-white`}>{winNos}</span>
                                                                        )}
                                                                    </div>}

                                                                {this.state.drawType == 13 && prevresult.win_number && prevresult.win_number.split(';').length > 0 && prevresult.win_number.split(';').map((winNos, inx) =>
                                                                    <ul className="zodiacBallSec Latestlukyresult game-13-balls rowGap" key={`aj_${inx}`}>
                                                                        <li >
                                                                            <a className={`game-13-balls-${parseInt(winNos)} game-13`}>
                                                                                <span>{winNos}</span>
                                                                            </a></li>
                                                                    </ul>
                                                                )}
                                                            </div>

                                                            <div className="dashed-border itemsCenter flexCol justifyCent">
                                                                <div className="text-center">
                                                                    <span>{t('lblTotalPrize')}:</span>
                                                                    <p>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(prevresult.total_prize)}</p>
                                                                </div>
                                                                <div className="text-center margin-top10">
                                                                    <span>{t('lblTotalWinners')}:</span>
                                                                    <p>{prevresult.total_winner}</p>
                                                                </div>
                                                            </div>
                                                            <div className="detailsSection flex gap-8">
                                                                <a className="show-popup1 bigpopupopen" onClick={() => { this.GetLatestWinner(prevresult) }}><img src="./assets/img/icons/Notes-3.svg" alt="details" /></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="pastDrawBtn mt-10">
                                            <button onClick={() => { this.GotoPastResultPage() }}
                                                className={`border-game${this.state.drawType} border-[1px] border-solid  px-14 py-2  rounded-full hover:bg-game${this.state.drawType} ${this.state.drawType != 11 ? `active:bg-game${this.state.drawType}` : ''} hover:text-white`}
                                            >
                                                <a>{t('lblViewAllDrawHistory')}</a>
                                            </button>
                                        </div>
                                    </div>

                                </li> */}
                                </ul> :
                                    <>
                                        <div class="noOrders">
                                            <img src="./assets/img/icons/sad.png" />
                                            <h3>{t("lblNoResults")}</h3>
                                            <p class="margin-bottom-20">{t("lblResultsEmpty")}</p>
                                            <div class="formCont updateBtn">
                                                <button onClick={() => { history.push("/") }}>{t('lblBuynow')}</button>
                                            </div>
                                        </div>
                                    </>}
                            </div >
                        </div >

                        <div class="pagination">
                            <div class="paginationLft">
                                {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{this.state.AnotherPrevResult && Math.ceil(this.state.AnotherPrevResult.length / this.state.NumberofRecord)} </span> {t('lblof')} <span>{this.state.AnotherPrevResult && this.state.AnotherPrevResult.length}</span> {t('lblentries')}
                            </div>
                            <div class="paginationLRht">
                                <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                            </div>
                        </div>
                    </>
                }

                {this.state.PrevDrawFlag && <WinnersList PastDrawStateObj={this.state.PastDrawStateObj} drawType={this.state.drawType} />}

                {/* {this.state.ViewAllResultFlag && <Viewdetailedresults drawtype={this.state.drawType} showClose={() => { this.BactGotoPastResultPage() }} send_db_id={this.state._dbdrawType} />} */}
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { breakdownlist } = state.accountReducer;
    const { AnotherPrevResult, RaffleResult } = state.gameReducer;
    return { user, AnotherPrevResult, RaffleResult, breakdownlist, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetPreviousResult: gameActions.GetPreviousResult,
    GetRaffleResults: gameActions.GetRaffleResults,
    ClearGetRaffleResults: gameActions.ClearGetRaffleResults
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Previousresult))